import { IFieldOptions } from '@/types/serverField.type'

export class FieldOptions {
  showTitle: boolean
  viewFilterField: Record<string, string>
  viewFilterFieldFromField: unknown
  formAdapterUuid: string | undefined

  // Возможные значения, которые не могут быть выбраны (select)
  nonSelectableValue: string | undefined

  changeOnStart: boolean

  // ID фоновой задачи для отслеживания прогресса через SSE
  backgroundTaskId: string | undefined

  // Количество строк в textarea (для полей типа text)
  rowsCount: number | undefined

  constructor (options: IFieldOptions) {
    this.showTitle = options?.showTitle !== false
    this.viewFilterFieldFromField = options?.__ViewFilterFieldFromField || null
    this.viewFilterField = options?.__ViewFilterField || {}
    this.formAdapterUuid = options?.FormAdapterUuid
    this.nonSelectableValue = options?.NonSelectableValue
    this.changeOnStart = options?.ChangeOnStart === true
    this.backgroundTaskId = options?.BackgroundTaskId
    this.rowsCount = options?.rowsCount
  }
}
